





























import mixins from 'vue-typed-mixins';
import UserUtils, { User } from '@/utils/UserUtils';
import cloneDeep from 'lodash.clonedeep';
import deepEqual from 'deep-equal';
import { Location } from 'vue-router';
export default mixins().extend({
  computed: {
    tabs(): any {
      return [
        {
          text: this.$i18n.tc('page.profile.details.navigation', 2),
          location: { name: 'profile-details' },
        },
        {
          text: this.$i18n.tc('page.profile.email.navigation', 2),
          location: { name: 'profile-email' },
        },
        {
          text: this.$i18n.tc('page.profile.password.navigation', 2),
          location: { name: 'profile-password' },
        },
      ];
    },
    tab(): undefined | number {
      return this.tabs?.findIndex(
        (tab: any) => this.$route.name === tab.location.name
      );
    },
  },
  data(): {
    pristine?: Partial<User>;
    user?: Partial<User>;
  } {
    return {
      pristine: undefined,
      user: undefined,
    };
  },
  async mounted() {
    this.$loading(true);
    try {
      const resp = await Promise.all([UserUtils.api.get(this.$session?.id)]);
      this.pristine = resp[0];
      this.user = cloneDeep(this.pristine);
    } catch (error) {
      this.$alert.show('mounted', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
    this.$loading(false);
  },
  methods: {
    async navigate(location: Location) {
      if (
        typeof location === 'string'
          ? this.$route.path !== location
          : this.$route.name !== location.name
      ) {
        let allowNavigation = !deepEqual(this.user, this.pristine)
          ? await this.$confirm(
              this.$i18n.t('validation.confirmation.navigation').toString()
            )
          : true;

        if (allowNavigation) {
          await this.$router.push(location);
          this.user = cloneDeep(this.pristine);
        }
      }
    },
    handlePristine(pristine: Partial<User>) {
      this.pristine = {
        ...this.pristine,
        ...cloneDeep(pristine),
      };
    },
  },
});
